import type { ReactNode } from "react";
import { PickerList } from "@/features/sparxsEditor/components/molecules/pickerList/pickerList";
import type { PickerListItem } from "@/features/sparxsEditor/components/molecules/pickerList/pickerList";
import { FloatingSuggestionPanel } from "@/features/sparxsEditor/components/molecules/floatingSuggestionPanel/floatingSuggestionPanel";
import { PICKER_LIST_FLOATING_CLASS } from "./variableTokenConstants";

export type VariableSuggestionItem = PickerListItem;

export interface VariableSuggestionListProps {
  items: PickerListItem[];
  selectedIndex: number;
  onSelect: (item: PickerListItem) => void;
  clientRect: (() => DOMRect | null) | null;
}

/**
 * Floating list for variable suggestions ({ trigger). Rendered in a portal, positioned with clientRect.
 * Uses shared PickerList molecule; keyboard nav is handled by the suggestion plugin's onKeyDown.
 */
export const VariableSuggestionList = ({
  items,
  selectedIndex,
  onSelect,
  clientRect,
}: VariableSuggestionListProps): ReactNode => {
  if (items.length === 0) return null;

  return (
    <FloatingSuggestionPanel clientRect={clientRect}>
      <PickerList
        items={items}
        onSelect={onSelect}
        selectedIndex={selectedIndex}
        optionIdPrefix="variable-suggestion"
        className={PICKER_LIST_FLOATING_CLASS}
      />
    </FloatingSuggestionPanel>
  );
};
